import React from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

function TipRSVP() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>How To Write an RSVP Card</h3>
          <div className="section">
            <p className="desc">
              Not sure what this card should say? Here are the basic components of an RSVP card.
            </p>
          </div>
          <div className="section">
            <p className="head">RSVP line:</p>
            <p className="desc">
              Include an RSVP deadline no less than four weeks from your wedding date (or according
              to any vendors’ requirements) and make sure it’s prominent. If dates are spelled out
              in the invitation, the RSVP deadline should follow suit.
            </p>
          </div>
          <div className="section">
            <p className="head">Name of guests:</p>
            <p className="desc">
              Here is where guests fill in their names on the blank line. This line is pre-printed
              with an “M” (for Mrs., Miss, or Mr.) on formal invitations.
            </p>
          </div>
          <div className="section">
            <p className="head">Attendance line:</p>
            <p className="desc">
              Pretty self-explanatory: guests mark the appropriate “yes” or “no” response. You can
              get creative with the exact wording here—see some examples below.
            </p>
          </div>
          <div className="section">
            <p className="head">Meal preference line:</p>
            <p className="desc">
              If you’re serving a full meal and have an aversion to utter chaos, ask guests for
              their meal preferences here. Include instructions for how to indicate their choice,
              followed by a list of the options (either specific entrées or protein/meal type
              offerings).
            </p>
            <p className="desc">
              For the full 411 on RSVP cards, including a variety of wording examples, head over to
              our{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/wedding-invitations/a-guide-to-wedding-invitation-rsvps/"
                target="_blank"
              >
                helpful expert advice
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipRSVP;
